<template>
  <b-table :fields=fields :items=users>

    <template v-slot:cell(gender)="row">
      {{ row.value ? (row.value == 'male' ? 'Herr' : 'Frau') : '' }}
    </template>

    <template v-slot:cell(firstname)="row">
      <router-link v-if=admin :to="{name: 'admin.users.details', params: {id: row.item.id}}">
        {{ row.value }}
      </router-link>

      <span v-else>
        {{ row.value }}
      </span>
    </template>

    <template v-slot:cell(lastname)="row">
      <router-link v-if=admin :to="{name: 'admin.users.details', params: {id: row.item.id}}">
        {{ row.value }}
      </router-link>

      <span v-else>
        {{ row.value }}
      </span>
    </template>

    <template v-slot:cell(coordinator)="row">
      <font-awesome-icon icon="check-circle" class="fa-lg" v-if="school && school.coordinatorId === row.item.id"/>
    </template>
  </b-table>
</template>
<script>
export default {
  name: 'SchoolUsersTable',
  props: ['school', 'users', 'admin'],
  data: function () {
    return {
      fields: [
        {key: 'gender', label: 'Anrede'},
        {key: 'firstname', label: 'Vorname'},
        {key: 'lastname', label: 'Nachname'},
        {key: 'email', label: 'Email'},
        {key: 'coordinator', label: 'Koordinator*in', class: 'text-center'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schools/UsersTable.vue